import { Component, OnInit, ViewEncapsulation, TemplateRef, Renderer2 } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MainService } from '@root/main.service';
import { HttpClient } from '@angular/common/http';
import { Locale } from '@root/models/Locale';
import { Menu } from '@root/models/Menu';
import { Reservation } from '@root/models/Reservation';
import { Department } from '@root/models/Department';
import {FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {MenuItem} from '@root/models/MenuItem';
import {OrderModel} from '@root/models/OrderModel';
import {Md5} from 'ts-md5/dist/md5';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Coupon} from '@root/models/Coupon';
import {ToastrService} from 'ngx-toastr';
import {TimeSlot} from '@root/models/TimeSlot';
import {BsLocaleService} from 'ngx-bootstrap/datepicker';
import { Injectable } from '@angular/core';
import { WindowReferenceService } from '@root/window-reference.service';
import {Event} from '@root/models/Event';
import { forkJoin } from 'rxjs';
import {colors} from '@angular/cli/utilities/color';
import { ViewChild, ElementRef } from '@angular/core';
@Component({
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class WidgetComponent implements OnInit {


  private readonly CHLEB_I_VINO_LOCALE_IDS = [
    325, 851, 1045, 1046, 1047, 1108
  ];
  private readonly VIALE_VERDE_LOCALE_IDS = [1070];
  private window;
  reservationPaymentModalRef?: BsModalRef;
  privacyModalRef?: BsModalRef;
  orderCouponRef?: BsModalRef;
  eventModalRef?: BsModalRef;
  minReservationDate: Date;
  maxReservationDate: Date;

  @ViewChild('appContainer') appContainer: ElementRef;
  @ViewChild('f') reservationForm: NgForm;
  @ViewChild('dp') datepicker: any;
  @ViewChild('nameField') nameField: any;
  @ViewChild('emailField') emailField: any;
  @ViewChild('agreementField') agreementField: any;
  @ViewChild('privacyField') privacyField: any;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private _http: MainService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private _localeService: BsLocaleService,
    private _windowRef: WindowReferenceService,
    private renderer: Renderer2
  ) {
    translate.addLangs(['en', 'pl', 'ru', 'ua']);
    translate.setDefaultLang('en');
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|pl|ru|ua/) ? browserLang : 'en');
    this.minReservationDate = new Date();
    this.minReservationDate.setDate(this.minReservationDate.getDate());
    this.maxReservationDate = new Date();

    if (browserLang === 'pl') {
      this._localeService.use('pl');
    } else {
      this._localeService.use('en');
    }

    this.window = _windowRef.nativeWindow;
  }

  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required])
  });
  phoneOrderForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required])
  });
  public locale_code;
  public sellway_token;
  public parentOrigin;
  private userLanguage;
  public localeModel: Locale;
  public menuModel: any[];
  public reservationModel: Reservation;
  public department: Department;
  style_background = '';
  next_step = false;
  step = 1;
  public personsList = null;
  // public aviable_reservations_list = null;
  public reservationSlotLimit = 0;
  public time_active = 0;
  public menuTab = false;
  public requestInProcess = false;
  public menuRequestInProgress = false;
  privacyDeliveryHandlerOpenedStyle: string;
  privacyDeliveryButtonCloseStyle: string;
  termsHandlerOpenedStyle: string;
  termsButtonCloseStyle: string;
  marketingHandlerOpenedStyle: string;
  marketingButtonCloseStyle: string;
  reservationDaysDisabled: [0,6];
  reservationTimeSlots: TimeSlot[];
  reservationTimeSlotsMessageCode: number;
  public reservationPaymentInProgress = false;
  public reservationPaymentCompleted = false;
  public reservationPaymentCompletedStatus = 4;
  public localeEvents: Event[] = [];
  public departmentPaymentValue: number = 0;

  // Events screen
  public showEventsScreen = false;
  public eventsScreenMonth: Date = new Date();
  public eventsForCurrentMonth: any[] = [];
  public selectedEventForDetails: any = null;

  // Selected timeslot snapshot (preserved for payment screen)
  public selectedTimeSlotSnapshot: any = null;

  // Dining options
  public diningOptions: any[] = [];
  public diningOptionsShowPrices = false;
  public selectedDiningOption: any = null;
  public currentGuestIndex: number = 0;
  public guestSelections: any[] = [];
  public showDishValidation: boolean = false;
  public showDishesScrollFade: boolean = false;
  private scrollListener: any = null;

  get hasDiningOptions(): boolean {
    return this.diningOptions && this.diningOptions.length > 0;
  }

  disabledDates = [

  ];

  // Orders
  public menuHandlerOpenedStyle: string;
  public menuButtonCloseStyle: string;
  public cartHandlerOpenedStyle: string;
  public cartButtonCloseStyle: string;
  public activeMenuItem: MenuItem;
  public activePositionCount = 1;
  public activePositionCost: any;
  public cart = [];
  public cartPossibleCounts = Array.from({length: 20}, (_, i) => i + 1);
  public cartStep = 0; // 0 = cart; 1 = checkout; 2 = finish
  public orderModel: OrderModel;
  public orderScheduledNowDate;
  public orderScheduledMinDate;
  public orderProcessing = false;
  public orderPlacedId = 0;
  public isDateAvailableForOrder = true;
  public timesAvailableForDate = [];
  public justAddedtoCartAnimation = false;
  public couponCode: string;
  public couponTmp: Coupon;
  public coupon: Coupon;
  public errorMsgShow: boolean;
  public errorLowPriceMsgShow: boolean;
  private pendingDate: Date = null;


  can_finish = function (f) {
    if (this.reservationModel.name && this.reservationModel.email && !f.form.controls['phone'].invalid && this.reservationModel.privacy_agreement && (this.reservationModel.agreement || this.localeModel.reservations_payments_terms_required === '0'))  {
      return true;
    }
    return false;
  };

  ngOnInit(): void {
    // Get locale code from URL
    this.userLanguage = navigator.language.split('-')[0];
    this.locale_code = location.search.split('cn=')[1];
    const sellwayParam = location.search.split('sellway_token=')[1];
    this.sellway_token = sellwayParam ? sellwayParam.split('&')[0] : '';
    this.parentOrigin = new URLSearchParams(location.search).get('parentOrigin');

    this.reservationModel = new Reservation();
    this.reservationModel.phone = '';
    this.reservationModel.persons = 0;
    this.reservationModel.reservationData = 0;
    this.reservationModel.department = null;
    this.reservationModel.language = this.userLanguage;

    // Extract and validate date parameter
    const dateParam = location.search.split('date=')[1];
    if (dateParam) {
      const dateValue = dateParam.split('&')[0];
      const parts = dateValue.split('-');
      if (parts.length === 3) {
        // Parse manually to avoid timezone issues (new Date('YYYY-MM-DD') is UTC)
        const parsedDate = new Date(
          parseInt(parts[0], 10),
          parseInt(parts[1], 10) - 1,
          parseInt(parts[2], 10)
        );
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (!isNaN(parsedDate.getTime()) && parsedDate >= today) {
          this.pendingDate = parsedDate;
        }
      }
    }

    if (this.sellway_token !== undefined) {
      this.reservationModel.sellway_token = this.sellway_token;
    }

    const urlParams = new URLSearchParams(location.search);
    const sourceParam = urlParams.get('source');
    if (sourceParam) {
      this.reservationModel.source = sourceParam;
    }

    this.localeModel = new Locale();
    this.localeModel.menuToken = '';

    if (this.locale_code) {
      this._http.getLocale(this.locale_code, this.userLanguage).subscribe(
        data => {
          this.localeModel = data;
        },
        error => console.log(error),
        () => this.processLocale()
      );
    }

    this.setupReservationCalendar();

    // Listen for postMessage from parent window (mrOpen with date)
    window.addEventListener('message', (event) => {
      if (event.data?.type === 'setDate' && event.data.date) {
        this.setDateFromMessage(event.data.date);
      }
    });
  }

  private setDateFromMessage(dateString: string) {
    const parts = dateString.split('-');
    if (parts.length === 3) {
      const parsedDate = new Date(
        parseInt(parts[0], 10),
        parseInt(parts[1], 10) - 1,
        parseInt(parts[2], 10)
      );
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (!isNaN(parsedDate.getTime()) && parsedDate >= today) {
        this.pendingDate = parsedDate;
        this.applyPendingDate();
      }
    }
  }

  private applyPendingDate() {
    if (this.pendingDate) {
      setTimeout(() => {
        this.reservationModel.reservationData = this.pendingDate;
        if (this.datepicker) {
          this.datepicker.bsValue = this.pendingDate;
        }
      }, 100);
    }
  }

  public setupReservationCalendar () {
    //TODO: ADD BLOCKDAYS AND BLOCKDATES

    // this.dpConfig.showWeekNumbers = false;
    // this.dpConfig.dateInputFormat = 'Do MMMM YYYY';
    // this.dpConfig.isAnimated = true;
    // this.minReservationDate = new Date();
    // this.minReservationDate.setDate(this.minReservationDate.getDate());
    //
    // this.reservationDaysDisabled = [0,6];
    // this.reservationDatesDisabled = [
    //   new Date('2021-08-20')
    // ]
  }


  openCouponModal (template) {
    this.orderCouponRef = this.modalService.show(template);
  }

  /**
   * Get locale information
   */
  processLocale () {
    this.orderModel = new OrderModel();
    this.processOrderModel();
    if (this.isChlabIVinoLocale()) {
      this.renderer.addClass(document.body, 'chleb_i_vino');
    }
    if (this.isVialeVerdeLocale()) {
      this.renderer.addClass(document.body, 'viale_verde');
    }
    if (this.localeModel.widget_side_img === '1') {
      this.style_background = 'url(' + this.localeModel.photo + ') no-repeat scroll 85px #ffffff';
    } else {
      this.style_background = 'none;';
    }
    this.reservationModel.code = this.localeModel.code;
    this.personsList = this.localeModel.personsList;
    if (this.localeModel.departments.length === 1) {
      this.reservationModel.department = this.localeModel.departments[0];
      this.orderModel.department = this.localeModel.departments[0];
      this.changeDepartment();
    } else {
      this.orderModel.department = null;
    }
    if (this.localeModel.menuToken) {
      this.loadMenu();
    }

    // Check if event mode should show events first screen
    if (this.localeModel.event_mode && this.localeModel.future_events && this.localeModel.future_events.length > 0) {
      this.showEventsScreen = true;
      // Auto-select first department if multiple
      if (this.localeModel.departments.length > 1) {
        this.reservationModel.department = this.localeModel.departments[0];
        this.changeDepartment();
      }
      // Set initial month to the first event's month
      const firstEvent = this.localeModel.future_events[0];
      this.eventsScreenMonth = new Date(firstEvent.date + 'T00:00:00');
      this.updateEventsForMonth();
    }
  }


  // Events screen methods
  updateEventsForMonth() {
    const year = this.eventsScreenMonth.getFullYear();
    const month = this.eventsScreenMonth.getMonth();
    this.eventsForCurrentMonth = (this.localeModel.future_events || []).filter(e => {
      const d = new Date(e.date + 'T00:00:00');
      return d.getFullYear() === year && d.getMonth() === month;
    });
  }

  hasEventsInPrevMonth(): boolean {
    const prev = new Date(this.eventsScreenMonth);
    prev.setMonth(prev.getMonth() - 1);
    return (this.localeModel.future_events || []).some(e => {
      const d = new Date(e.date + 'T00:00:00');
      return d.getFullYear() === prev.getFullYear() && d.getMonth() === prev.getMonth();
    });
  }

  hasEventsInNextMonth(): boolean {
    const next = new Date(this.eventsScreenMonth);
    next.setMonth(next.getMonth() + 1);
    return (this.localeModel.future_events || []).some(e => {
      const d = new Date(e.date + 'T00:00:00');
      return d.getFullYear() === next.getFullYear() && d.getMonth() === next.getMonth();
    });
  }

  goToPrevMonth() {
    const prev = new Date(this.eventsScreenMonth);
    prev.setMonth(prev.getMonth() - 1);
    this.eventsScreenMonth = prev;
    this.updateEventsForMonth();
  }

  goToNextMonth() {
    const next = new Date(this.eventsScreenMonth);
    next.setMonth(next.getMonth() + 1);
    this.eventsScreenMonth = next;
    this.updateEventsForMonth();
  }

  getMonthName(date: Date): string {
    return date.toLocaleString(this.translate.currentLang || 'en', { month: 'long', year: 'numeric' });
  }

  bookEvent(event: any) {
    this.showEventsScreen = false;
    // Set date from event
    this.reservationModel.reservationData = new Date(event.date + 'T00:00:00');
    // Set minimum available guests - use personsList minimum or event min_people, whichever is greater
    let minPeople = 1;
    if (this.personsList && this.personsList.length > 0) {
      minPeople = this.personsList[0].amount;
    }
    if (event.min_people > 0 && event.min_people > minPeople) {
      minPeople = event.min_people;
    }
    this.reservationModel.persons = minPeople;
    // Auto-select first hall if hall is required
    if (this.reservationModel.department && this.reservationModel.department.halls && this.reservationModel.department.halls.length > 0 && +this.reservationModel.preferred_hall_id === 0) {
      this.reservationModel.preferred_hall_id = this.reservationModel.department.halls[0].id;
    }
    // Trigger timeslot loading
    this.checkAvailableTimesTimes();
  }

  goToStandardReservation() {
    this.showEventsScreen = false;
    this.scrollToTop();
  }

  goToEventsScreen() {
    this.cleanReservation();
    this.showEventsScreen = true;
    this.updateEventsForMonth();
    this.scrollToTop();
  }

  scrollToTop() {
    setTimeout(() => {
      // Scroll every element on the page that has scrollTop > 0
      document.querySelectorAll('*').forEach(el => {
        if (el.scrollTop > 0) {
          el.scrollTop = 0;
        }
      });
      window.scrollTo(0, 0);
    }, 100);
  }

  get hasEventsScreen(): boolean {
    return this.localeModel && this.localeModel.event_mode && this.localeModel.future_events && this.localeModel.future_events.length > 0;
  }

  formatEventDate(dateStr: string): string {
    const d = new Date(dateStr + 'T00:00:00');
    return d.toLocaleDateString(this.translate.currentLang || 'en', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  isFirstEventOfDay(event: any, index: number): boolean {
    if (index === 0) return true;
    return this.eventsForCurrentMonth[index - 1].date !== event.date;
  }

  getEventDayName(dateStr: string): string {
    const d = new Date(dateStr + 'T00:00:00');
    return d.toLocaleDateString(this.translate.currentLang || 'en', { weekday: 'short' }).toUpperCase();
  }

  getEventDayNumber(dateStr: string): string {
    const d = new Date(dateStr + 'T00:00:00');
    return d.getDate().toString();
  }

  openEventDetails(event: any) {
    this.selectedEventForDetails = event;
  }

  closeEventDetails() {
    this.selectedEventForDetails = null;
  }

  bookFromDetails() {
    const event = this.selectedEventForDetails;
    this.selectedEventForDetails = null;
    this.bookEvent(event);
  }

  loadingTimeSlots = false;

  checkAvailableTimesTimes() {
    if (this.loadingTimeSlots) return;
    if (!this.reservationModel.reservationData) return;
    if (this.reservationModel.persons < 1) {
      this.reservationModel.persons = 0;
      this.reservationModel.time = null;
      this.next_step = false;
      return;
    }

    if (this.reservationModel.department.halls && this.reservationModel.department.halls.length === 1 && +this.reservationModel.preferred_hall_id === 0) {
      this.reservationModel.preferred_hall_id = this.reservationModel.department.halls[0].id;
    }

    if (+this.reservationModel.department.hall_required === 1 && +this.reservationModel.preferred_hall_id === 0) {
      this.reservationTimeSlots = null;
      this.reservationTimeSlotsMessageCode = null;
      return;
    }

    this.loadingTimeSlots = true;

    this.next_step = false;
    this.time_active = -1;
    this.reservationModel.time = null;

    this.reservationTimeSlots = null;
    this.reservationTimeSlotsMessageCode = null;

    this.reservationModel.department.payment_required = false;
    this.reservationModel.department.payment_val = 0;
    this.localeEvents = [];

    forkJoin({
      resTimeSlots: this._http.getTimeSlots(
        this.reservationModel.department.id,
        this.getHumanReservationDate(),
        this.reservationModel.persons,
        this.reservationModel.preferred_hall_id,
        this.reservationModel.duration_id
      ),
      resPayment: this._http.getPaymentInfo(
        this.reservationModel.department.id,
        this.getHumanReservationDate(),
        this.reservationModel.persons,
        null,
        null,
        this.reservationModel.preferred_hall_id || null
      )
    }).subscribe(
      data => {
        //Handle timeSlots
        this.reservationTimeSlots = data.resTimeSlots.TimeSlot;
        this.reservationTimeSlotsMessageCode = data.resTimeSlots.msg_code;

        //Handle payment
        this.departmentPaymentValue = 0;
        if (data.resPayment.value > 0) {
          this.departmentPaymentValue = data.resPayment.value;
          this.reservationModel.department.payment_required = true;
          this.reservationModel.department.payment_val = data.resPayment.value;
        }
        if (data.resPayment.events) {
          this.localeEvents = data.resPayment.events;
        }
      },
      error => {
        console.log(error);
        this.loadingTimeSlots = false;
      },
      () => {
        this.loadingTimeSlots = false;
      }
    );
  }

  openLinkInNewTab(url) {
    this.reservationPaymentInProgress = true;
    if (url.isSubmitForm && url.isSubmitForm === true && url.form.length > 0) {
      if (window.self !== window.top) {
        let parentOrigin = document.referrer ? new URL(document.referrer).origin : '*';
        if (this.parentOrigin) {
          parentOrigin = decodeURIComponent(this.parentOrigin);
        }

        window.top.postMessage({ type: 'submitForm', formHtml: url.form }, parentOrigin);
      } else {
        this.submitHiddenForm(url.form);
      }
    } else {
      window.open(url, '_blank').focus();
    }
    this.checkReservationStatus();
  }

  checkReservationStatus () {
    var self = this;
    var sub = window.setInterval(function(){
      self._http.getReservationStatus(self.reservationModel.code).subscribe(
        data => {
          if (data['status'] < 4) {
            clearInterval(sub);
          }
          if (data['status'] !== 4 && data['status'] !== self.reservationPaymentCompletedStatus) {
            self.reservationPaymentInProgress = false;
            self.reservationPaymentCompleted = true;
            self.reservationPaymentCompletedStatus = data['status'];
          }
        },
        error => self._showError(error),
        () => {  }
      );

    }, 5000);
  }

  processOrderModel () {
    this.orderModel.deliveryOption = null;
    this.orderModel.isScheduled = null;
    this.orderModel.scheduledTimeVal = null;
    this.orderModel.paymentMethod = null;
    this.orderModel.needInvoice = false;
    this.orderModel.agreement = false;
    this.orderModel.privacy_agreement = false;
    this.orderModel.status = 0;

    const today = new Date();
    this.orderScheduledNowDate = today.toISOString().split('T')[0];
    this.orderScheduledMinDate = new Date().toISOString().split('T')[0];
  }


  /**
   * Load menu
   */
  loadMenu(menuTab = false) {
    this.menuRequestInProgress = true;
    this.menuTab = menuTab;
    if (!this.menuModel) {
      this._http.getMenu(this.localeModel.menuToken).subscribe(
        data => this.setMenuModel(data),
        error => {
          console.log(error);
          this.menuRequestInProgress = false;
        },
        () => {
          this.menuRequestInProgress = false;
        },
      );
    }
  }

  /**
   * @param data
   */
  setMenuModel(data) {
    this.menuModel = data.flatMap(category => [
      category,
      ...(category.subcategories || [])
    ]);

    console.log(this.menuModel);

    console.log(data);
  }

  showMarketing (show = true) {
    if (show) {
      this.marketingHandlerOpenedStyle = 'handler-opened';
      this.marketingButtonCloseStyle = 'make-close';
    } else {
      this.marketingHandlerOpenedStyle = '';
      this.marketingButtonCloseStyle = '';
    }
  }

  agreementReservationCheckbox() {
    this.reservationModel.agreement = !this.reservationModel.agreement;
  }
  privacyReservationAgreement () {
    this.reservationModel.privacy_agreement = !this.reservationModel.privacy_agreement;
  }
  marketingReservationAgreement () {
    console.log('click');
    console.log(this.reservationModel.marketing_consent);
    this.reservationModel.marketing_consent = !this.reservationModel.marketing_consent;
    console.log(this.reservationModel.marketing_consent);
  }

  /**
   * Process reservation — either go to dining options or send directly
   */
  sendReservation() {
    if (this.requestInProcess) {
      return;
    }

    this.markAllFieldsAsTouched();

    if (!this.isFormValid(null)) {
      return;
    }

    // If dining options exist, go to dining selection step instead of sending
    if (this.hasDiningOptions) {
      this.step = 3;
      return;
    }

    this.submitReservation();
  }

  /**
   * Actually submit reservation to backend
   */
  submitReservation() {
    if (this.requestInProcess) {
      return;
    }

    this.requestInProcess = true;

    this._http.sendReservation(this.reservationModel).subscribe(
      data => {
        if (data['status'] === 409) {
          this.toastr.error(this.translate.instant('BOOK.NO_TABLES_AVAILABLE'), '', {timeOut: 5000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
          this.requestInProcess = false;
          this.goBackToTimeSlots();
          return;
        } else if (data['status'] === 500) {
          this.toastr.error(this.translate.instant('BOOK.SERVER_ERROR'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
          return this.processError();
        } else if (data['status'] === 400) {
          this.toastr.error(this.translate.instant('BOOK.WRONG_PHONE'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
          return this.processError();
        } else {
          this.reservationModel.reservation_code = data.reservation_code;
          this.reservationModel.reservation_status = data.reservation_status;
          this.reservationModel.payment_url = data.payment_url;
          this.reservationModel.code = data.code;
          this.reservationModel.is_queued = data.is_queued || 0;
          if (data.payment_url) {
            this.reservationModel.department.payment_required = true;
          }
          this.processReservationResponse(data);
        }
      },
      error => {
        this.toastr.error(this.translate.instant('BOOK.WRONG_RESERVATION'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
      },
      () => false
    );
  }

  processReservationResponse (data) {
    this.step = 6;
    this.requestInProcess = false;

    // Fire reservation tracking script locally (for direct/non-iframe mode)
    if (typeof this.window.sendReservation !== 'undefined') {
      this.window.sendReservation(this.reservationModel.phone?.number, this.reservationModel.email);
    }

    // Notify parent window (for iframe mode)
    if (window.self !== window.top) {
      let parentOrigin = document.referrer ? new URL(document.referrer).origin : '*';
      if (this.parentOrigin) {
        parentOrigin = decodeURIComponent(this.parentOrigin);
      }
      window.top.postMessage({
        type: 'reservationCompleted',
        phone: this.reservationModel.phone?.number,
        email: this.reservationModel.email
      }, parentOrigin);
    }
  }

  private submitHiddenForm(formHtml: string) {
    const container = document.createElement('div');
    container.style.display = 'none';
    container.innerHTML = formHtml;

    document.body.appendChild(container);

    const form = container.querySelector('form') as HTMLFormElement;
    if (form) {
      setTimeout(() => {
        form.submit();
        document.body.removeChild(container);
      }, 50);
    }
  }

  processError() {
    this.step = 2;
    this.requestInProcess = false;
    return true;
  }

  goBackToTimeSlots() {
    this.step = 1;
    this.checkAvailableTimesTimes();
  }

  changeDepartment() {
    if (this.reservationModel.department.id === 0 ||
      this.reservationModel.department.id === null ||
      this.reservationModel.department.id === undefined) {
      return;
    }
    this.reservationModel.persons = 0;
    this.reservationModel.reservationData = 0;
    if (this.reservationModel.department.halls && this.reservationModel.department.halls.length === 1) {
      this.reservationModel.preferred_hall_id = this.reservationModel.department.halls[0].id;
    } else {
      this.reservationModel.preferred_hall_id = 0;
    }
    if (this.reservationModel.department) {
      this._http.getDepartment(this.reservationModel.department.id, 0).subscribe(
        data => this.department = data,
        error => console.log(error),
        () => this.processDepartment(),
      );
    }
  }

  processDepartment () {
    this.personsList = this.department.personsList;
    // this.aviable_reservations_list = this.department.reservationList;
    this.reservationSlotLimit = this.department.reservationSlotLimit;

    if (this.department.durationOptions[0]) {
      // @ts-ignore
      this.reservationModel.duration_id = this.department.durationOptions[0].id;
    }

    // Load dining options
    this.diningOptions = this.department.diningOptions || [];
    this.diningOptionsShowPrices = !!this.department.diningOptionsShowPrices;

    if (this.department.maxDaysInReservationCalendar > 0) {
      this.maxReservationDate.setDate(this.maxReservationDate.getDate() + this.department.maxDaysInReservationCalendar);
    }

    // Apply pending date from URL parameter or postMessage
    this.applyPendingDate();

    return;
  }

  unsetDepartment () {
    this.department = null;
    this.personsList = 0;
    this.step = 1;
    this.next_step = false;
  }

  cleanReservation () {
    this.reservationModel = new Reservation();
    this.reservationModel.phone = '';
    this.reservationModel.persons = 0;
    this.reservationModel.reservationData = 0;
    this.reservationModel.department = null;
    this.reservationModel.language = this.userLanguage;

    // Reset dining state
    this.selectedDiningOption = null;
    this.currentGuestIndex = 0;
    this.guestSelections = [];

    this.processLocale();

    this.step = 1;
    this.personsList = 0;
    this.next_step = false;
  }

  // Dining option methods

  // "Table only" — skip dining, send reservation directly
  selectTableOnly() {
    this.selectedDiningOption = { id: null, name: '', price: 0, categories: [] };
    this.reservationModel.dining_option_id = null;
    this.guestSelections = [];
    this.submitReservation();
  }

  selectDiningOption(option: any) {
    this.selectedDiningOption = option;
    this.reservationModel.dining_option_id = option.id;

    if (option.categories && option.categories.length > 0) {
      // Initialize per-guest selections
      this.guestSelections = [];
      for (let i = 0; i < this.reservationModel.persons; i++) {
        this.guestSelections.push({
          guest_index: i,
          items: []
        });
      }
      this.currentGuestIndex = 0;
      this.step = 4; // Dish selection
      setTimeout(() => this.startScrollFadeCheck(), 200);
    } else {
      this.guestSelections = [];
      this.step = 5; // Summary
    }
  }

  selectDishForGuest(categoryId: number, itemId: number) {
    const selection = this.guestSelections[this.currentGuestIndex];
    if (!selection) return;

    // Find if category allows multiple
    const category = this.selectedDiningOption.categories.find(c => c.category_id === categoryId);
    const allowMultiple = category && category.allow_multiple;

    if (allowMultiple) {
      // Toggle item
      const existingIndex = selection.items.findIndex(i => i.menu_item_id === itemId && i.category_id === categoryId);
      if (existingIndex >= 0) {
        selection.items.splice(existingIndex, 1);
      } else {
        selection.items.push({ menu_item_id: itemId, category_id: categoryId });
      }
    } else {
      // Single select: replace existing item in this category
      selection.items = selection.items.filter(i => i.category_id !== categoryId);
      selection.items.push({ menu_item_id: itemId, category_id: categoryId });
    }
  }

  isItemSelected(categoryId: number, itemId: number): boolean {
    const selection = this.guestSelections[this.currentGuestIndex];
    if (!selection) return false;
    return selection.items.some(i => i.menu_item_id === itemId && i.category_id === categoryId);
  }

  getSelectedItemName(guestIndex: number, categoryId: number): string {
    return this.getSelectedItemNames(guestIndex, categoryId).join(', ');
  }

  getSelectedItemNames(guestIndex: number, categoryId: number): string[] {
    return this.getSelectedItemDetails(guestIndex, categoryId).map(d => d.name);
  }

  getSelectedItemDetails(guestIndex: number, categoryId: number): {name: string, price: number}[] {
    const selection = this.guestSelections[guestIndex];
    if (!selection) return [];
    const selectedItems = selection.items.filter(i => i.category_id === categoryId);
    const category = this.selectedDiningOption.categories.find(c => c.category_id === categoryId);
    if (!category) return [];
    return selectedItems.map(si => {
      const item = category.items.find(i => i.id === si.menu_item_id);
      return item ? { name: item.name, price: item.price || 0 } : null;
    }).filter(d => d);
  }

  nextGuest() {
    if (!this.hasRequiredSelectionsForGuest(this.currentGuestIndex)) {
      this.showDishValidation = true;
      this.toastr.error(this.translate.instant('BOOK.REQUIRED_DISHES'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
      return;
    }
    this.showDishValidation = false;
    if (this.currentGuestIndex < this.reservationModel.persons - 1) {
      this.currentGuestIndex++;
    } else {
      this.step = 5; // Summary
      this.stopScrollFadeCheck();
    }
    this.scrollToTop();
  }

  hasRequiredSelectionsForGuest(guestIndex: number): boolean {
    if (!this.selectedDiningOption?.categories) return true;
    const selection = this.guestSelections[guestIndex];
    if (!selection) return true;
    return this.selectedDiningOption.categories
      .filter(c => c.is_required)
      .every(c => selection.items.some(i => i.category_id === c.category_id));
  }

  isCategoryMissing(categoryId: number): boolean {
    if (!this.showDishValidation) return false;
    const category = this.selectedDiningOption?.categories?.find(c => c.category_id === categoryId);
    if (!category || !category.is_required) return false;
    const selection = this.guestSelections[this.currentGuestIndex];
    if (!selection) return true;
    return !selection.items.some(i => i.category_id === categoryId);
  }

  previousGuest() {
    if (this.currentGuestIndex > 0) {
      this.currentGuestIndex--;
    }
    this.scrollToTop();
  }

  goBackToDiningOptions() {
    this.stopScrollFadeCheck();
    this.selectedDiningOption = null;
    this.reservationModel.dining_option_id = null;
    this.step = 3;
  }

  goBackToDishes() {
    this.currentGuestIndex = 0;
    this.step = 4;
    setTimeout(() => this.startScrollFadeCheck(), 200);
  }

  getDiningOptionTotal(): number {
    if (!this.selectedDiningOption) return 0;
    if (this.selectedDiningOption.pay_at_venue) {
      return this.departmentPaymentValue;
    }
    const diningTotal = this.getDiningOnlyPrice();
    return this.departmentPaymentValue + diningTotal;
  }

  startScrollFadeCheck() {
    this.stopScrollFadeCheck();
    const container = document.querySelector('.mr-app-container');
    if (container) {
      this.scrollListener = () => {
        const isScrollable = container.scrollHeight > container.clientHeight + 20;
        const atBottom = container.scrollHeight - container.scrollTop - container.clientHeight < 20;
        this.showDishesScrollFade = isScrollable && !atBottom;
      };
      container.addEventListener('scroll', this.scrollListener);
      // Initial check with delay to let DOM render
      setTimeout(() => this.scrollListener(), 300);
    }
  }

  stopScrollFadeCheck() {
    if (this.scrollListener) {
      const container = document.querySelector('.mr-app-container');
      if (container) {
        container.removeEventListener('scroll', this.scrollListener);
      }
      this.scrollListener = null;
    }
    this.showDishesScrollFade = false;
  }

  getGuestItemsSummary(guestIndex: number): string {
    return this.getGuestItemsSummaryList(guestIndex).map(d => d.name).join(', ');
  }

  getGuestItemsSummaryList(guestIndex: number): {name: string, price: number}[] {
    if (!this.selectedDiningOption?.categories) return [];
    return this.selectedDiningOption.categories
      .flatMap(c => this.getSelectedItemDetails(guestIndex, c.category_id));
  }

  hasAnyOptionImage(): boolean {
    return this.diningOptions && this.diningOptions.some(o => o.image);
  }

  getDiningOnlyPrice(): number {
    if (!this.selectedDiningOption || !this.selectedDiningOption.price) return 0;
    return this.selectedDiningOption.price_per_person
      ? this.selectedDiningOption.price * this.reservationModel.persons
      : this.selectedDiningOption.price;
  }

  confirmReservation() {
    // Attach guest selections and total price to reservation model
    this.reservationModel.guest_selections = this.guestSelections;
    this.reservationModel.price = this.getDiningOptionTotal();
    this.submitReservation();
  }

  validateEmail (email) {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  showPrivacy (template: TemplateRef<any>) {
    this.privacyModalRef = this.modalService.show(template);
  }

  showEventInfo (template: TemplateRef<any>) {
    this.eventModalRef = this.modalService.show(template);
  }

  showDeliveryPrivacy (show = true) {
    if (show) {
      this.privacyDeliveryHandlerOpenedStyle = 'handler-opened';
      this.privacyDeliveryButtonCloseStyle = 'make-close';
    } else {
      this.privacyDeliveryHandlerOpenedStyle = '';
      this.privacyDeliveryButtonCloseStyle = '';
    }
  }
  showDeliveryTerms (show = true) {
    if (show) {
      this.termsHandlerOpenedStyle = 'handler-opened';
      this.termsButtonCloseStyle = 'make-close';
    } else {
      this.termsHandlerOpenedStyle = '';
      this.termsButtonCloseStyle = '';
    }
  }
  showReservationPaymentRegulamin (template: TemplateRef<any>) {
    this.reservationPaymentModalRef = this.modalService.show(template);
  }

  setReservationDuration(option) {
    this.reservationModel.duration_id = option.id;
    this.checkAvailableTimesTimes();
  }

  getEventForTimeSlot(time: string): Event | null {
    return this.localeEvents.find(e => e.start_time === time) || null;
  }

  hasMultipleEvents(): boolean {
    return this.localeEvents.length > 1;
  }

  // Check if there's exactly one all-day event (no start/end time)
  isSingleAllDayEvent(): boolean {
    return this.localeEvents.length === 1 &&
           !this.localeEvents[0].start_time &&
           !this.localeEvents[0].end_time;
  }

  // Get events that have start and end times (for collapsible display)
  getTimedEvents(): Event[] {
    return this.localeEvents.filter(e => e.start_time && e.end_time);
  }

  // Check if any event has a reservation price
  hasEventsWithPrice(): boolean {
    return this.localeEvents.some(e => e.price && e.price > 0);
  }

  getSlotPrice(time: any): string | null {
    let price: number = null;
    if (time.event && (time.event.price > 0 || (time.event.min_people_price > 0 && this.reservationModel.persons >= time.event.min_people))) {
      const event = this.localeEvents.find(e => e.start_time === time.time);
      price = event ? this.getEventDisplayPrice(event) : this.getTimeSlotEventPrice(time);
    } else if (time.paid_value > 0) {
      price = time.paid_value;
    }
    if (price === null) return null;
    return price % 1 === 0 ? String(Math.round(price)) : String(price);
  }

  getSlotPriceLabel(time: any): string {
    if (time.event && (time.event.price > 0 || (time.event.min_people_price > 0 && this.reservationModel.persons >= time.event.min_people))) {
      const event = this.localeEvents.find(e => e.start_time === time.time);
      if (event) {
        return this.isEventPricePerPerson(event) ? '/os.' : '';
      }
      if (time.event.min_people && time.event.min_people_price > 0 && this.reservationModel.persons >= time.event.min_people) {
        return time.event.min_people_depends_of_people ? '/os.' : '';
      }
      return time.event.depends_of_people ? '/os.' : '';
    }
    if (time.paid_value > 0) {
      return time.paid_per_person ? '/os.' : '';
    }
    return '';
  }

  private getTimeSlotEventPrice(time: any): number {
    if (time.event.min_people && time.event.min_people_price > 0
        && this.reservationModel.persons >= time.event.min_people) {
      return time.event.min_people_price;
    }
    return time.event.price;
  }

  getEventDisplayPrice(event: Event): number {
    if (event.min_people && event.min_people_price && this.reservationModel.persons >= event.min_people) {
      return event.min_people_price;
    }
    return event.price;
  }

  isEventPricePerPerson(event: Event): boolean {
    if (event.min_people && event.min_people_price && this.reservationModel.persons >= event.min_people) {
      return !!event.min_people_depends_of_people;
    }
    return !!event.depends_of_people;
  }

  getSelectedTimeSlot(): any {
    if (this.time_active >= 0 && this.reservationTimeSlots && this.reservationTimeSlots[this.time_active]) {
      return this.reservationTimeSlots[this.time_active];
    }
    return this.selectedTimeSlotSnapshot;
  }

  getEventPriceBreakdown(): string {
    const slot = this.getSelectedTimeSlot();
    if (!slot?.event) return '';
    const price = this.getTimeSlotEventPrice(slot);
    const perPerson = slot.event.depends_of_people || (slot.event.min_people_depends_of_people && this.reservationModel.persons >= slot.event.min_people);
    if (perPerson) {
      return `${this.reservationModel.persons} × ${price} zł = ${price * this.reservationModel.persons} zł`;
    }
    return `${price} zł`;
  }

  getRegularPriceBreakdown(): string {
    const slot = this.getSelectedTimeSlot();
    if (!slot?.regular_price) return '';
    if (slot.regular_price_per_person) {
      return `${this.reservationModel.persons} × ${slot.regular_price} zł = ${slot.regular_price * this.reservationModel.persons} zł`;
    }
    return `${slot.regular_price} zł`;
  }

  getRegularPriceDisplay(time: any): string {
    const price = time.regular_price;
    if (price === null || price === undefined) return '';
    return price % 1 === 0 ? String(Math.round(price)) : String(price);
  }

  // Check if any timeslot is marked as paid (time-period pricing)
  hasPaidTimeSlots(): boolean {
    return this.reservationTimeSlots && this.reservationTimeSlots.some(t => t.paid);
  }

  // Track expanded state for collapsible events
  expandedEventIds: Set<number> = new Set();

  toggleEventExpanded(eventId: number): void {
    if (this.expandedEventIds.has(eventId)) {
      this.expandedEventIds.delete(eventId);
    } else {
      this.expandedEventIds.add(eventId);
    }
  }

  isEventExpanded(eventId: number): boolean {
    return this.expandedEventIds.has(eventId);
  }

  processTimeClick (time, index) {
    if (time.available) {
      // Reset to department payment first
      if (this.departmentPaymentValue > 0) {
        this.reservationModel.department.payment_required = true;
        this.reservationModel.department.payment_val = this.departmentPaymentValue;
      } else {
        this.reservationModel.department.payment_required = false;
        this.reservationModel.department.payment_val = 0;
      }

      // Check for event payment (including tiered pricing)
      if (time.event) {
        const fullEvent = this.localeEvents.find(e => e.start_time === time.time);
        const resolvedPrice = fullEvent ? this.getEventDisplayPrice(fullEvent) : time.event.price;
        if (resolvedPrice && resolvedPrice > 0) {
          const isPerPerson = fullEvent ? this.isEventPricePerPerson(fullEvent) : !!time.event.depends_of_people;
          let totalVal = isPerPerson
            ? resolvedPrice * this.reservationModel.persons
            : resolvedPrice;

          // Add regular reservation price if add_reservation_price is enabled
          if (time.event.add_reservation_price && time.regular_price > 0) {
            totalVal += time.regular_price_per_person
              ? time.regular_price * this.reservationModel.persons
              : time.regular_price;
          }

          this.reservationModel.department.payment_required = true;
          this.reservationModel.department.payment_val = totalVal;
        }
      }

      // Save timeslot snapshot for payment screen
      this.selectedTimeSlotSnapshot = time;

      // Check time-period payment — re-fetch with time param
      if (time.paid && !time.event) {
        this._http.getPaymentInfo(
          this.reservationModel.department.id,
          this.getHumanReservationDate(),
          this.reservationModel.persons,
          null,
          time.time,
          this.reservationModel.preferred_hall_id || null
        ).subscribe(data => {
          if (data.value > 0) {
            this.reservationModel.department.payment_required = true;
            this.reservationModel.department.payment_val = data.value;
          }
        });
      }

      this.time_active = index;
      this.next_step = true;
      this.reservationModel.time = time.time;
      this.step = 2;
    }
  }
  getTranslation (text) {
    return this.translate.instant(text);
  }
  menuGetShortTitle (name) {
    if (name && name.length > 35) {
      return name.substring(0, 35) + '...';
    }
    return name;
  }
  menuGetShortDescription (description) {
    if (description && description.length > 35) {
      return description.substring(0, 35) + '...';
    }
    return description;
  }
  showItemInfo (show, menuItem) {
    if (show) {
      this.activeMenuItem = menuItem;
      this.activePositionCount = 1;
      this.activePositionCost = this.activePositionCount * this.activeMenuItem.price;
      this.menuHandlerOpenedStyle = 'handler-opened';
      this.menuButtonCloseStyle = 'make-close';
    } else {
      this.activeMenuItem = null;
      this.menuHandlerOpenedStyle = '';
      this.menuButtonCloseStyle = '';
    }
  }
  increaseActivePositionCount () {
    this.activePositionCount++;
    this.activePositionCost = this.getTotalItemPrice(this.activePositionCount, this.activeMenuItem.price);
  }
  decreaseActivePositionCount () {
    if (this.activePositionCount > 1) {
      this.activePositionCount--;
      this.activePositionCost = this.getTotalItemPrice(this.activePositionCount, this.activeMenuItem.price);
    }
  }
  getTotalItemPrice (cost, quantity) {
    return (cost * quantity).toFixed(2);
  }
  addItemToCart(item, count = null, price = null) {
    this.justAddedtoCartAnimation = true;
    setTimeout(() => {  this.justAddedtoCartAnimation = false; }, 500);


    const cartItem = {
      itemId: item.id,
      item: item,
      quantity: count ? count : this.activePositionCount,
      price: price ? price : this.activeMenuItem.price
    };

    const index = this.cart.findIndex(function(o) {
      if (o.itemId === cartItem.itemId) {
        return true;
      }
    });

    // tslint:disable-next-line:comment-format
    //Detect if itim is already in cart. In case if it is already exists we need to add only quantity
    if (index >= 0) {
      this.cart[index].quantity = this.cart[index].quantity + (count ? count : this.activePositionCount);
    } else {
      this.cart.push(cartItem);
    }

    this.showItemInfo(false, null);
  }
  showCart(shouldOpen) {
    this.cartStep = 0;
    if (shouldOpen) {
      this.cartHandlerOpenedStyle = 'handler-opened';
      this.cartButtonCloseStyle = 'make-close';
    } else {
      this.cartHandlerOpenedStyle = '';
      this.cartButtonCloseStyle = '';
    }
  }
  amount(item) {
    return item.price * item.quantity;
  }
  sum(prev, next) {
    return prev + next;
  }
  getCartTotal () {
    if (this.cart.length === 0) {
      return 0;
    }
    return this.cart.map(this.amount).reduce(this.sum).toFixed(2);
  }
  countDelivery () {
    const cartTotal = this.getCartTotal();
    const deliveryCost = parseFloat(String(this.orderModel.department.delivery_cost));
    const freeDeliveryFrom = parseFloat(String(this.orderModel.department.free_delivery_from));
    if (this.orderModel.deliveryOption === 'PICKUP') {
      return 0.00;
    }
    if (deliveryCost > 0 && (cartTotal < freeDeliveryFrom || !freeDeliveryFrom)) {
      return parseFloat(String(deliveryCost)).toFixed(2);
    }
    return 0.00;
  }
  getFinalTotal(withoutCoupon = true) {
    const cartTotalCost = this.getCartTotal();
    const deliveryCost = this.countDelivery();

    // tslint:disable-next-line:max-line-length
    if (!withoutCoupon && this.coupon && this.coupon.name) {
      if (this.coupon.type == 'PERSENTAGE') {
        return (parseFloat(<string>cartTotalCost) * (1 - (this.coupon.value / 100))).toFixed(2);
      } else {
        return (parseFloat(<string>cartTotalCost) - this.coupon.value).toFixed(2);
      }
    }
    return (parseFloat(<string>cartTotalCost) + parseFloat(<string>deliveryCost)).toFixed(2);
  }
  deleteFromCart (cartItem) {
    const index = this.cart.findIndex(function(o) {
      if (o.itemId === cartItem.itemId && o.quantity === cartItem.quantity) {
        return true;
      }
    });
    if (index !== -1) {
      this.cart.splice(index, 1);
    }

    if (this.cart.length < 1) {
      this.showCart(false);
    }
  }

  /**
   * 0 - Cart table
   * 1 - Form data
   * 2 - Confirmation
   * 3 - Result
   */
  cartNextStep() {
    if (this.cartStep === 0 && !this.orderModel.department) {
      this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_LOCATION'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
      return;
    }
    if (this.cartStep === 0 && this.getCartTotal() < parseFloat(String(this.orderModel.department.minimal_delivery_cost))) {
      const text = this.translate.instant('MENU.ORDER_FORM_ALERT_MINIMAL_DELIVERY') + ' '
        + this.orderModel.department.minimal_delivery_cost + ' '
        + this.translate.instant('MENU.currency');
      this.toastr.error(text, '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
      return;
    }
    if (this.cartStep === 1) {
      if (!this.orderModel.department) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_LOCATION'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      if (!this.orderModel.deliveryOption) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_DELIVERY_TYPE'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      if (!this.orderModel.isScheduled) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_DELIVERY_TIME_OPTION'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      // tslint:disable-next-line:radix
      if (this.orderModel.isScheduled === 'SCHEDULED' && !this.orderModel.scheduledDateVal) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_DELIVERY_TIME'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      if (this.orderModel.isScheduled === 'SCHEDULED' && !this.orderModel.scheduledTimeVal) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_DELIVERY_TIME'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      if (!this.orderModel.paymentMethod) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_PAYMENT_METHOD'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      if (this.orderModel.deliveryOption === 'DELIVERY' && !this.orderModel.deliveryAddress) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_DELIVERY_ADDRESS'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      if (!this.orderModel.name) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_NAME'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      if (this.isNeedToAskPhoneNumber()) {
        if (this.phoneOrderForm.controls['phone'].invalid) {
          this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_PHONE'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
          return;
        }
      }
      if (!this.orderModel.email || !this.validateEmail(this.orderModel.email)) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_EMAIL'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      if (this.orderModel.needInvoice) {
        if (!this.orderModel.companyName) {
          this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_COMPANY_NAME'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
          return;
        }
        if (!this.orderModel.companyAddress) {
          this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_COMPANY_ADDRESS'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
          return;
        }
        if (!this.orderModel.companyNip) {
          this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_COMPANY_NIP'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
          return;
        }
      }
    }
    this.cartStep++;
  }
  cartPrevStep() {
    this.cartStep--;
  }
  needInvoiceCheckbox () {
    this.orderModel.needInvoice = !this.orderModel.needInvoice;
  }
  agreementCheckbox() {
    this.orderModel.agreement = !this.orderModel.agreement;
  }
  privacyDeliveryAgreement () {
    this.orderModel.privacy_agreement = !this.orderModel.privacy_agreement;
  }
  processOrder() {
    if (!this.orderModel.agreement) {
      this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_AGREEMENT'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
      return;
    }
    if (!this.orderModel.privacy_agreement) {
      this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_AGREEMENT'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
      return;
    }
    this.orderProcessing = true;
    this.orderModel.cart = this.cart;
    const md5 = new Md5();
    this.orderModel.timeAdded = Date.now().toString();
    this.orderModel.checksum = md5.appendStr(this.orderModel.timeAdded + this.localeModel.id + this.orderModel.email).end().toString();
    this.menuRequestInProgress = true;
    // tslint:disable-next-line:max-line-length
    if (this.coupon && this.coupon.name) {
      this.orderModel.coupon_id = this.coupon.id;
      this.orderModel.coupon_name = this.coupon.name;
    }
    this._http.sendOrder(this.orderModel).subscribe(
      data => {
        this.orderPlacedId = data.order_id;
        this.orderPlaced();
      },
      error => {
        this.menuRequestInProgress = false;
        this.toastr.error(this.translate.instant('MENU.ORDER_PLACE_ERROR'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        this.orderProcessing = false;
      },
      () => {
        this.menuRequestInProgress = false;
      }
    );
  }
  orderPlaced() {
    this.orderProcessing = false;
    this.cartStep = 3;
  }
  clearOrder() {
    this.showCart(false);
    this.orderModel = new OrderModel();
    this.processOrderModel();
    this.cart = [];
  }

  applyCoupon() {
    this.errorLowPriceMsgShow = false;
    this._http.getCoupon(this.localeModel.id, this.couponCode).subscribe(
      data => { this.couponTmp = data; },
      error => this._showError(error),
      () => { this._checkCoupon(); }
    );
  }

  _showError(error) {
    this.errorMsgShow = true;
  }

  _checkCoupon () {
    if (this.couponTmp) {
      if (this.couponTmp.minimum_order_sum && this.getCartTotal() < this.couponTmp.minimum_order_sum) {
        this.errorLowPriceMsgShow = true;
      } else {
        this.coupon = this.couponTmp;
        this.orderCouponRef.hide();
      }
    }
  }

  checkOrderDate (date = null) {
    this.isDateAvailableForOrder = true;
    let response = '';
    if (this.orderModel.isScheduled === 'ASAP') {
      this._http.getOrderDatesAvailable(this.orderModel.department.id).subscribe(
        data => response = data,
        error => console.log(error),
        () => {
          // @ts-ignore
          if (response.is_day_off == 1 || response.hour_now < response.opens_at || response.hour_now >= response.closes_at) {
            this.isDateAvailableForOrder = false;
            return;
          } else {
            this.isDateAvailableForOrder = true;
            return;
          }
        }
      );
      return;
    } else if (this.orderModel.isScheduled === 'SCHEDULED' && date) {
      this._http.getOrderDatesAvailable(this.orderModel.department.id, date).subscribe(
        data => response = data,
        error => console.log(error),
        () => {
          // @ts-ignore
          if (response.is_day_off == 1) {
            this.toastr.error('Przepraszamy. Nie przyjmujemy zamówień w tym dniu (' + date + '). Wybierz inną datę.', '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
            this.isDateAvailableForOrder = false;
            return;
          }
          const isToday = date == new Date().toISOString().split('T')[0];
          // @ts-ignore
          if (isToday && response.hour_now >= response.closes_at) {
            this.toastr.error('Przepraszamy. Nie przyjmujemy już zamówień w tym dniu. Wybierz inną datę.', '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
            this.isDateAvailableForOrder = false;
            return;
          }
          // @ts-ignore
          if (isToday && response.hour_now >= response.opens_at) {
            // @ts-ignore
            this.prepareTimeAvailableSelector(response.hour_now + 1, response.closes_at);
            if (this.timesAvailableForDate.length === 0) {
              this.toastr.error('Przepraszamy. Nie przyjmujemy już zamówień w tym dniu. Wybierz inną datę.', '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
              this.isDateAvailableForOrder = false;
              return;
            }
          } else {
            // @ts-ignore
            this.prepareTimeAvailableSelector(response.opens_at, response.closes_at);
            if (this.timesAvailableForDate.length === 0) {
              this.toastr.error('Przepraszamy. Nie przyjmujemy już zamówień w tym dniu. Wybierz inną datę.', '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
              this.isDateAvailableForOrder = false;
              return;
            }
          }
          this.isDateAvailableForOrder = true;
          return;
        }
      );
      return;
    }
  }

  prepareTimeAvailableSelector (startTime, endTime) {
    const times = [];
    for (let step = startTime; step < endTime; step++) {
      times.push(step + ':00');
      times.push(step + ':30');
    }
    this.timesAvailableForDate = times;
  }
  isNeedToAskPhoneNumber () {
    return (this.orderModel.department.delivery_delivery_phone > 0 && this.orderModel.deliveryOption === 'DELIVERY') ||
      (this.orderModel.department.delivery_pickup_phone > 0 && this.orderModel.deliveryOption === 'PICKUP');
  }
  getHumanReservationDate () {
    if (this.reservationModel.reservationData) {
      let d = this.reservationModel.reservationData.getDate();
      let m = this.reservationModel.reservationData.getMonth() + 1; //Month from 0 to 11
      let y = this.reservationModel.reservationData.getFullYear();
      return '' + (d <= 9 ? '0' + d : d) + '.' + (m<=9 ? '0' + m : m) + '.' + y;
    }

    return '';
  }

  isFormValid(f: NgForm): boolean {
    const isNameValid = this.reservationModel.name && this.reservationModel.name.trim().length > 0;
    const isEmailValid = this.reservationModel.email && this.validateEmail(this.reservationModel.email);
    const isPhoneValid = this.phoneForm.get('phone')?.valid;
    const isPrivacyAgreed = this.reservationModel.privacy_agreement;

    let isPaymentAgreed = true;
    if (this.localeModel.reservations_payments_terms && !(String(this.localeModel.reservations_payments_terms_required) === '0')) {
      isPaymentAgreed = this.reservationModel.agreement;
    }

    return isNameValid && isEmailValid && isPhoneValid && isPrivacyAgreed && isPaymentAgreed;
  }

  markAllFieldsAsTouched() {
    this.phoneForm.markAllAsTouched();

    if (this.nameField) this.nameField.control.markAsTouched();
    if (this.emailField) this.emailField.control.markAsTouched();
    if (this.agreementField) this.agreementField.control.markAsTouched();
    if (this.privacyField) this.privacyField.control.markAsTouched();
  }

  isChlabIVinoLocale(): boolean {
    return this.localeModel?.id && this.CHLEB_I_VINO_LOCALE_IDS.includes(Number(this.localeModel.id));
  }

  isVialeVerdeLocale(): boolean {
    return this.localeModel?.id && this.VIALE_VERDE_LOCALE_IDS.includes(Number(this.localeModel.id));
  }

  private readonly CUSTOM_NO_TIMESLOTS_TEXTS = {
    pl: { title: 'W dniu dzisiejszym nie przyjmujemy już rezerwacji.', description: 'Zapraszamy do odwiedzenia restauracji - postaramy się znaleźć dostępne miejsce.' },
    en: { title: 'We are no longer accepting reservations for today.', description: 'You are welcome to visit the restaurant - we will do our best to find you an available table.' },
    ua: { title: 'На сьогодні ми вже не приймаємо бронювання.', description: 'Запрошуємо відвідати ресторан - ми постараємося знайти для вас вільне місце.' },
    ru: { title: 'На сегодняшний день мы больше не принимаем бронирования.', description: 'Приглашаем посетить ресторан - мы постараемся найти для вас свободное место.' },
  };

  getCustomNoTimeSlotsTitle(): string {
    const lang = this.translate.currentLang || 'en';
    return (this.CUSTOM_NO_TIMESLOTS_TEXTS[lang] || this.CUSTOM_NO_TIMESLOTS_TEXTS['en']).title;
  }

  getCustomNoTimeSlotsDescription(): string {
    const lang = this.translate.currentLang || 'en';
    return (this.CUSTOM_NO_TIMESLOTS_TEXTS[lang] || this.CUSTOM_NO_TIMESLOTS_TEXTS['en']).description;
  }

  shouldShowTabs(): boolean {
    let count = 1; // Delivery або Book - завжди 1
    if (this.localeModel?.menuToken) {
      count++;
    }
    return count > 1;
  }

  onCombinedAgreementChange(value: boolean) {
    this.reservationModel.agreement = value;
    this.reservationModel.privacy_agreement = value;
  }

}
